import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import LoginPage from "./pages/authPages/LoginPage";
import SignUpPage from "./pages/authPages/SignUpPage";
import AuthLayout from "./pages/authPages/AuthLayout";

import ProtectedRoute from "./components/security/ProtectedRoute";
import ManagerLayout from "./pages/manager/ManagerLayout";
import { useEffect } from "react";
import useAppStore from "./store/appStore";
import ManageCategoriesPage from "./pages/manager/categories/ManageCategoriesPage";
import MenuItemViewer from "./pages/menu/MenuItemViewer";
import LandingPageV2 from "./pages/LandingPageV2";
import WorkingHoursPage from "./pages/manager/workinghours/WorkingHoursPage";
import ProfilePage from "./pages/manager/profile/ProfilePage";
import AdminLayout from "./pages/admin/AdminLayout";
import DashboardPage from "./pages/admin/DashboardPage";
import ManageRestaurantsPage from "./pages/admin/ManageRestaurantsPage";
import AccessDeniedPage from "./pages/authPages/AccessDeniedPage";
import NoRestaurantPage from "./pages/manager/NoRestaurantPage";
import { Role } from "./model/entities";
import ForgotPasswordPage from "./pages/authPages/ForgotPasswordPage";
import MenuViewer2 from "./pages/menu/MenuViewer2";
import MenuItemViewer2 from "./pages/menu/MenuItemViewer2";
import QRCodeManagementPage from "./pages/manager/qrCodes/QRCodeManagementPage";
import ManagerDashboardPage from "./pages/manager/dashboard/ManagerDashboardPage";
import ManageMenuPage from "./pages/admin/menuManagement/ManageMenuPage";
import MenuManagementPage2 from "./pages/manager/MenuManagementPage2";
import AnalyticsPage from "./pages/manager/analytics/AnalyticsPage";

function App() {
  const { darkMode, direction } = useAppStore();

  useEffect(() => {
    document.documentElement.dir = direction;
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode, direction]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<LandingPageV2 />} index></Route>
        <Route path="access-denied" element={<AccessDeniedPage />} />
        <Route path="/auth" element={<AuthLayout />}>
          <Route path="" element={<LoginPage />} index />
          <Route path="signup" element={<SignUpPage />} />
          <Route path="forgot-password" element={<ForgotPasswordPage />} />
        </Route>
        <Route
          path="/admin"
          element={
            <ProtectedRoute role={Role.ADMIN}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<DashboardPage />} index />
          <Route path="restaurants" element={<ManageRestaurantsPage />} />
          <Route path="menu" element={<ManageMenuPage />} />
        </Route>
        <Route
          path="/manager"
          element={
            <ProtectedRoute role={Role.OWNER}>
              <ManagerLayout />
            </ProtectedRoute>
          }
        >
          <Route
            index
            path=""
            element={<Navigate to={"dashboard"} replace />}
          />
          <Route path="dashboard" element={<ManagerDashboardPage />} />
          <Route path="menu" element={<MenuManagementPage2 />} />
          <Route path="categories" element={<ManageCategoriesPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="qr-codes" element={<QRCodeManagementPage />} />
          <Route path="working-hours" element={<WorkingHoursPage />} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>
        <Route
          path="/manager/no-restaurant"
          element={
            <ProtectedRoute role={Role.OWNER}>
              <NoRestaurantPage />
            </ProtectedRoute>
          }
        />
        {/* Add Menu viewer route */}
        <Route path="/menu/:restaurantId" element={<MenuViewer2 />} />
        <Route path="/menu" element={<MenuViewer2 />} />
        <Route
          path="/menu/:restaurantId/category/:categoryId/item/:itemId"
          element={<MenuItemViewer2 />}
        />
        <Route
          path="/menu/demo/category/:categoryId/item/:itemId"
          element={<MenuItemViewer />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
